module.exports = __webpack_public_path__ + "img/body-3.44009d5e.png";